import { useCadPageParams } from '@/pages/CADPage/hooks'
import { useDocumentVersion } from '@/pages/CADPage/components/ScreenshotPanelButton/hooks/useDocumentVersion'

export const useDocumentVersionId = () => {
  const { documentId, dv: selectedDocumentVersionId } = useCadPageParams()
  const { data: documentVersion } = useDocumentVersion({
    documentId,
    documentVersionId: selectedDocumentVersionId,
  })

  return documentVersion?.id
}
